<template>
<div>
    <StatusBar />
    <nav class="topnav">
        <router-link to="/" class="brand">
            <div class="brand-mark"></div>
            <div class="brand-text">ASO<em>Radar</em></div>
        </router-link>

        <button class="nav-burger" :class="{open: navOpen}" @click="navOpen = !navOpen" aria-label="Toggle navigation">
            <span></span><span></span><span></span>
        </button>

        <div class="nav-links" :class="{open: navOpen}" @click="navOpen = false">
            <router-link to="/startapp" class="nav-magic">// STARTAPP</router-link>
            <router-link to="/mcp">// MCP</router-link>
            <a :href="`${$state.siteProto}://api.${$state.siteDomain}/docs`" target="_blank" rel="noopener">// API</a>
            <router-link to="/dashboard">// Dashboard</router-link>
            <router-link to="/tokens">// Tokens</router-link>
            <router-link to="/webhooks">// Webhooks</router-link>
            <router-link to="/plan">// Plan</router-link>
            <router-link to="/billing">// Billing</router-link>
            <router-link to="/settings">// Settings</router-link>
        </div>

        <div class="nav-cta">
            <router-link to="/logout" class="btn-ghost" v-if="$state.context.id">Logout</router-link>
            <router-link to="/login" class="btn-amber" v-else>▶ Login</router-link>
        </div>
    </nav>
    <main>
        <router-view></router-view>
    </main>
    <Footer />
</div>
</template>

<script>
import { EventBus } from "@/bus"
import Footer from './Footer'
import StatusBar from './StatusBar'
export default {
    components: { Footer, StatusBar },
    data() { return { navOpen: false } },
    watch: {
        $route() {
            this.navOpen = false
            this.checkLogin(this.$state.context)
        }
    },
    created() {
        EventBus.on("context:loaded", this.checkLogin)
        if (!this.$state.context.id) {
            EventBus.emit("context:request")
        }
    },
    beforeUnmount() {
        EventBus.off("context:loaded", this.checkLogin)
    },
    methods: {
        checkLogin(context) {
            if (context.loaded && !context.id) {
                window.location.href = '/login'
            }
        }
    }
}
</script>

<style scoped>
.topnav :deep(.router-link-active) { color: var(--accent); }
.topnav :deep(.router-link-active::after) {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: var(--accent);
}
</style>
